export default "__VITE_ASSET__CmojLbuY__"